module.exports = __webpack_public_path__ + "static/media/search.67041b75.png";